import Cookies from 'js-cookie';
const CookieFunction = (type, name, value, expires = 365, callback = () => {}) => {
  console.log('nameeee', name);
  if (typeof window !== 'undefined' && typeof document !== 'undefined') {
    if (type == 'set') {
      Cookies.set(name, value, {
        expires: expires,
        // , path:"/"
      });
      callback();
    }
    if (type == 'remove') {
      Cookies.remove(
        name,
        //   ,{
        //   path: '/',
        // }
      );
    }
    if (type == 'get') {
      return Cookies.get(name) ? Cookies.get(name) : undefined;
    }
  }
};

export default CookieFunction;
